export const REPOS_PAGE_URL = "/spacelift-repos";

export const getRepoUrl = (repoId: string) => `${REPOS_PAGE_URL}/${repoId}`;

export const getRepoRevisionsPageUrl = (repoId: string) => `${getRepoUrl(repoId)}/commits`;

export const getRepoRevisionUrl = (repoId: string, sha: string) =>
  `${getRepoRevisionsPageUrl(repoId)}/${sha}`;

export const getRepoDownloadUrl = (slug: string, revisionSha: string) =>
  `/repos/${slug}/revisions/${revisionSha}/download`;
